// extracted by mini-css-extract-plugin
export var avatarContainer = "_gg-0";
export var avatarTypingWave = "_gg-i";
export var gray = "_gg-f";
export var green = "_gg-c";
export var icon = "_gg-9";
export var image = "_gg-1";
export var lg = "_gg-6";
export var md = "_gg-5";
export var presenceDot = "_gg-b";
export var red = "_gg-d";
export var sm = "_gg-4";
export var status = "_gg-a";
export var typingDot = "_gg-h";
export var typingPill = "_gg-g";
export var xl = "_gg-7";
export var xs = "_gg-3";
export var xxl = "_gg-8";
export var xxs = "_gg-2";
export var yellow = "_gg-e";